module.exports = __webpack_public_path__ + "static/media/HomeSectionFour.c5ba2537.webp";